import { IconButton, styled as muiStyled, css } from "@mui/material";
import styled from "@emotion/styled";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px 14px;
  overflow: auto;
  border: solid 1px #dee2ec;
  border-radius: 4px;
  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const Header = styled.div`
  display: flex;
`;

export const LeftSection = styled.div`
  display: flex;
  font-size: 14px;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
`;

export const BadgeWrapper = styled.div`
  margin: 0 8px;
  display: flex;
  align-items: center;
`;

export const Body = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Contents = styled.div`
  width: 100%;
  font-size: 14px;
`;

export const CollapseButton = muiStyled(IconButton)`
  width: 20px;
  height: 16px;
  padding: 0;

  ${(props: { $collapsed: any }) =>
    props.$collapsed &&
    css`
      transform: rotate(180deg);
    `}
`;
